var checkShouldIncludeClickType = function checkShouldIncludeClickType(detailPageName) {
  var pages = ['build-and-price', 'homepage', 'srp', 'car-subst-serv', 'slp_new', 'slp_used', 'slp_cpo', 'buy-online-help', 'dealer-home-services', 'srp_no_results', 'my_cars', 'my_searches', 'marketing_landing_page-see-it-find-it'];
  if (pages.includes(detailPageName)) {
    return true;
  }

  // handle separately since these are too specific -- ex: slp_make_honda, slp_cat_sedan
  if (detailPageName.includes('make') || detailPageName.includes('cat')) {
    return true;
  }
  return false;
};
export default checkShouldIncludeClickType;